module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new/0099.jpg?v=8008fbc3";